module.exports = __webpack_public_path__ + "static/media/active_video_thumb1.5d5c9a0a.png";